import { AxiosError } from "axios";
import { $api } from "./interceptor";
import { toast } from "App";
import { FinancialMetrics, FinancialMetricTypesEnum } from "types/financial";
import { financialStore } from "views/store/useFinancialStore";

const FinancialService = () => {
  const getFinancialMetrics = async (type?: FinancialMetricTypesEnum) => {
    try {
      const { data } = await $api.get<FinancialMetrics>(
          type ? `api/financial-metrics/fee/info?type=${type}` : "api/financial-metrics/fee/info"
      );

      if (data.type === FinancialMetricTypesEnum.BASE_FEE) {
        financialStore.setState({ fee: data.value });
      }

      if (data.type === FinancialMetricTypesEnum.TRANSACTION_USD_BOUND) {
        financialStore.setState({ transactionUsdBound: data.value });
      }

      if (data.type === FinancialMetricTypesEnum.LOW_BASE_FEE_USD) {
        financialStore.setState({ lowFeeUsd: data.value });
      }

      if (data.type === FinancialMetricTypesEnum.CROWDFUNDING_USD_BOUND) {
        financialStore.setState({ crowdfundingUsdBound: data.value });
      }

      return data.value;
    } catch (e) {
      console.log(e);
      if (e instanceof AxiosError) {
        toast({
          title: "Error",
          description: e.response?.data.message,
          status: "error",
          position: "top-right",
        });
      } else {
        toast({
          title: "Error fetching fee",
          status: "error",
          isClosable: true,
          position: "top-right",
        });
      }
      throw e;
    }
  };

  const getFinancialFollowingsMetrics = async () => {
    try {
      const { data } = await $api.get<FinancialMetrics>(
          "api/financial-metrics/fee/followings/info"
      );

      if (data.type === FinancialMetricTypesEnum.FOLLOWINGS_BUYS_FEE) {
        financialStore.setState({ followingsFee: data.value });
      }

      return data.value;
    } catch (e) {
      console.log(e);
      if (e instanceof AxiosError) {
        toast({
          title: "Error",
          description: e.response?.data.message,
          status: "error",
          position: "top-right",
        });
      } else {
        toast({
          title: "Error fetching fee",
          status: "error",
          isClosable: true,
          position: "top-right",
        });
      }
      throw e;
    }
  };


  const getTokenCreatorMetrics = async () => {
    try {
      const { data } = await $api.get<FinancialMetrics>(
          "api/financial-metrics/fee/token-creator/info"
      );

      if (data.type === FinancialMetricTypesEnum.TOKEN_CREATOR_FEE) {
        financialStore.setState({ tokenCreatorFee: data.value });
      }

      return data.value;
    } catch (e) {
      console.log(e);
      if (e instanceof AxiosError) {
        toast({
          title: "Error",
          description: e.response?.data.message,
          status: "error",
          position: "top-right",
        });
      } else {
        toast({
          title: "Error fetching fee",
          status: "error",
          isClosable: true,
          position: "top-right",
        });
      }
      throw e;
    }
  };
  const setFee = async (fee: number, type= FinancialMetricTypesEnum.BASE_FEE) => {
    try {
      const payload = { value: fee, type  };
      await $api.post("api/financial-metrics", payload);
    } catch (e) {
      console.log(e);
      if (e instanceof AxiosError) {
        toast({
          title: "Error",
          description: e.response?.data.message,
          status: "error",
          position: "top-right",
        });
      } else {
        toast({
          title: "Error setting new fee",
          status: "error",
          isClosable: true,
          position: "top-right",
        });
      }
      throw e;
    }
  };

  return {
    getFinancialMetrics,
    setFee,
    getFinancialFollowingsMetrics,
    getTokenCreatorMetrics
  };
};

export const financialService = FinancialService();
